export enum MasterDataTabsCodes {
  All = 'all',
  Archive = 'archive',
}

export enum MasterDataViewsCodes {
  List = 'list',
  Tree = 'tree',
}
